import { module } from 'modujs';
import Swiper, { Navigation } from 'swiper';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.initSwiper()
    }

    initSwiper() {
        this.carousel = new Swiper(this.el, {
            modules: [Navigation],
            spaceBetween: 10,
            slidesPerView: 1.333,
            grabCursor: true,
            threshold: 3,
            navigation: {
                nextEl: '[data-navigation="next"]',
                prevEl: '[data-navigation="prev"]',
            },
            breakpoints: {
                1000: {
                  slidesPerView: 3
                }
            },
            on: {
                init: () => {
                    //Prevent lazy-load offset bug
                    this.call('update', null, 'Scroll');
                }
            }
        })
    }

    destroy() {
        super.destroy()

        this.carousel?.destroy(true, true);
    }
}
